var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBulletSolid = function SvgBulletSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "bullet-solid_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bullet-solid_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 8.667a3.333 3.333 0 1 0 0 6.666 3.333 3.333 0 0 0 0-6.667"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bullet-solid_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 8h8v8H8z"
  })))));
};
export { SvgBulletSolid as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNDczNDdfMjM0MykiPjxwYXRoIGQ9Ik0xMiA4LjY2NjVDMTAuMTU5MSA4LjY2NjUgOC42NjY2OSAxMC4xNTg5IDguNjY2NjkgMTEuOTk5OEM4LjY2NjY5IDEzLjg0MDggMTAuMTU5MSAxNS4zMzMyIDEyIDE1LjMzMzJDMTMuODQxIDE1LjMzMzIgMTUuMzMzNCAxMy44NDA4IDE1LjMzMzQgMTEuOTk5OEMxNS4zMzM0IDEwLjE1ODkgMTMuODQxIDguNjY2NSAxMiA4LjY2NjVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L2c+PGRlZnM+PGNsaXBQYXRoIGlkPSJjbGlwMF80NzM0N18yMzQzIj48cmVjdCB3aWR0aD0iOCIgaGVpZ2h0PSI4IiBmaWxsPSJjdXJyZW50Q29sb3IiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDggOCkiLz48L2NsaXBQYXRoPjwvZGVmcz48L3N2Zz4=";